import type Highcharts from "highcharts";
import t from "../../../../i18n";
import seriesColors from "./seriesColors";
import { zIndexChart } from "@ui/Highcharts/BetterHighcharts";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";
import { hasDiagnosticData } from "../../useNoDataIntervals";
import type { IndexedFailureValues } from "../../../../api/useIndexedFailureValues";

export const CONFIDENCE_AREA_ID = "ConfidenceArea";

function getConfidenceData({
  analyses,
  indexedFailureValues,
}: {
  analyses: ActiveAnalysis[];
  indexedFailureValues: IndexedFailureValues;
}) {
  const confidenceAreaPoints = analyses.reduce<Highcharts.PointOptionsObject[]>(
    (points, analysis, index) => {
      const previousAnalysis = analyses[index - 1];
      if (previousAnalysis !== undefined && previousAnalysis.group !== analysis.group) {
        points.push({
          x: (previousAnalysis.date + analysis.date) / 2,
          high: undefined,
          low: undefined,
        });
      }

      points.push({
        x: analysis.date,
        high: hasDiagnosticData(analysis, indexedFailureValues) ? -1 : undefined,
        low: 0,
      });
      return points;
    },
    [],
  );

  return confidenceAreaPoints;
}

function getConfidenceAreaSerie({
  analyses,
  indexedFailureValues,
  yAxisId,
  legendIndex,
}: {
  analyses: ActiveAnalysis[];
  indexedFailureValues: IndexedFailureValues;
  yAxisId: string;
  legendIndex: number;
}): Highcharts.SeriesArearangeOptions {
  const data: Highcharts.PointOptionsObject[] = getConfidenceData({
    analyses,
    indexedFailureValues,
  });

  return {
    id: CONFIDENCE_AREA_ID, // in order to have same visible series
    yAxis: yAxisId,
    name: t("charts.legend.confidence_area"),
    zIndex: zIndexChart.areaSeries + 2,
    color: seriesColors.confidenceArea,
    fillColor: seriesColors.fadedConfidenceArea,
    type: "arearange" as const,
    replicateInNavigator: true,
    data,
    showInLegend: true,
    legendIndex,
  };
}

export default getConfidenceAreaSerie;
